export default "__VITE_ASSET__CgPWGwAG__"